import { createContext, useContext } from 'react';
// import { io } from 'socket.io-client';

export const SocketContext = createContext();

export const SocketProvider = SocketContext.Provider;

export const useSocket = () => useContext(SocketContext);
